import { TABLE_NAMES } from "shared/types/enums";

export const INITIAL_RELOAD_ITEMS = {
    [TABLE_NAMES.Changes]: 0,
    [TABLE_NAMES.Companies]: 0,
    [TABLE_NAMES.ConfigurationChanges]: 0,
    [TABLE_NAMES.ConfigurationOverview]: 0,
    [TABLE_NAMES.DesktopLicenses]: 0,
    [TABLE_NAMES.DeviceGroups]: 0,
    [TABLE_NAMES.DeviceModels]: 0,
    [TABLE_NAMES.DeviceModelTaskCompatibilities]: 0,
    [TABLE_NAMES.Devices]: 0,
    [TABLE_NAMES.Files]: 0,
    [TABLE_NAMES.OfflineLicenses]: 0,
    [TABLE_NAMES.Permissions]: 0,
    [TABLE_NAMES.ProductCodes]: 0,
    [TABLE_NAMES.Roles]: 0,
    [TABLE_NAMES.TaskGroups]: 0,
    [TABLE_NAMES.Tasks]: 0,
    [TABLE_NAMES.Users]: 0
};
